import { z } from 'zod';
export var SearchTags;
(function (SearchTags) {
    SearchTags.requestSchema = z.object({
        query: z.string(),
    });
    SearchTags.responseSchema = z.object({
        results: z.array(z.object({
            id: z.number(),
            name: z.string(),
            metadata: z.object({
                canRemove: z.boolean().optional(),
                segmentIdentifier: z.string().nullable().optional(),
            }).optional(),
        })),
    });
})(SearchTags || (SearchTags = {}));
